import Step from "@frog/source/models/Step.js"
import World from "@frog/source/models/World.js"
import Stage from "@frog/source/models/Stage.js"
import skills from "@frog/source/data/skills/skills.js"

export default class Reactions {
    static getSteps(stage) {
        let steps = []

        while(Reactions.getDeaths(stage).length > 0) {
            const deaths = Reactions.getDeaths(stage)
            if(deaths.length > 0) {
                deaths.forEach((death) => {
                    const unit = stage.units[death.unitKey]
                    if(unit.skills[death.type] != undefined) {
                        const skill = skills.get(stage.units[death.unitKey].skills[death.type])
                        if(skill != undefined
                        && skill.calculateStep instanceof Function) {
                            const step = skill.calculateStep({
                                "performerKey": unit.key,
                                "position": unit.position, // own position...?
                                "stage": stage,
                            })
                            stage = step.omegastage
                            steps.push(step)
                        }
                    }
                    // TODO: what happens if multiple folks die at once, and i try to
                    // run their skills all off the same stage (not a rolling omegastage)
                    // I need to have something similiar to Step.add(step, deltastage)
                    // but for Action.add(action, step)
                })

                deaths.forEach((death) => {
                    steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].key))
                    stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

                    steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].type))
                    stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
                })

                // One big death event for all the units dying.
                // TO THINK ABOUT: How to handle death text?
                // TO THINK ABOUT: How to overlap this and the death text with the killing blows?
                // TODO: change this to the new schema v2
                const step = Step.instantiate({
                    "type": "death",
                    "alphastage": stage,
                    "deltastages": deaths.map((death) => {
                        return {
                            "annotation": {"type": death.type, "position": stage.units[death.unitKey].position},
                            "units": {[death.unitKey]: {"isDead": true}},
                        }
                    })
                })
                stage = step.omegastage
                steps.push(step)
            }
        }

        // const unit = action.omegastage.units[death.unitKey]
        // if(DEATH_DIALOGUE[unit.class] != undefined) {
        //     DEATH_DIALOGUE[unit.class].forEach((dialogue) => {
        //         addStep(action, Step.instantiate({
        //             "type": "say",
        //             "alphastage": action.omegastage,
        //
        //             "deltastages": [
        //                 {
        //                     "mark": 0,
        //                     "dialogue": dialogue
        //                 }
        //             ],
        //             "isImportant": true,
        //             "duration": Infinity,
        //         }))
        //     })
        //     addStep(action, Step.instantiate({
        //         "type": "unsay",
        //         "alphastage": action.omegastage,
        //         "deltastages": [
        //             {
        //                 "mark": 0,
        //                 "dialogue": null
        //             }
        //         ],
        //     }))
        // }

        // HEY! We should be returning multiple steps, right...?
        // And not one step with multiple deltastages because they
        // have different animations and can be skipped individually, right?
        // Can we capture steps and deltastages as the same thing?
        // 1. stop cloning the alpha and omega for each step; let it be one
        // continuous state
        // 2. call steps within steps?? so i can run an animation within an
        // animation, like death before or after or during an attack?
        // can i pause with the same logic of steps? are these mutually
        // exclusively performed animations?

        return steps
    }
    static getDeaths(stage) {
        const deaths = Object.values(stage.units).map((unit) => {
            if(unit.type == "zone") return // Zones can not be killed.
            if(unit.isDead == true) return // The dead can not be rekilled.
            if(unit.hasBeenRemoved == true) return
            if(unit.position.x == -10 && unit.position.y == -10) return

            if(unit.health <= 0) {
                return {"unitKey": unit.key, "type": "death-by-damage"}
            }

            const killzone = Object.values(stage.units).find((nextunit) => {
                return nextunit.type == "zone"
                    && nextunit.intent == "kill"
                    && nextunit.position.x == unit.position.x
                    && nextunit.position.y == unit.position.y
            })
            if(killzone != undefined) {
                return {"unitKey": unit.key, "type": "death-by-falling"}
            }

            const nextTerrain = World.getTerrain(stage.world, unit.position)
            if(nextTerrain == undefined) {
                return {"unitKey": unit.key, "type": "death-by-falling"}
            }
            // TODO: Death by leaving zone?
            // TODO: Death by change of height?
            // TODO: Death by being over "z<0"
        })

        return deaths.filter((death) => !!death)
    }
}
